const pt = {
  'sign-in': 'Entrar',
  'sign-out': 'Sair',
  'hire': 'Contrate talento',
};

export default pt;